import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_landing } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import MainNavDropdown from './MainNavDropdown'

export const guides = [
  { title: n_landing.gnb_menu_4.list_1, link: '/student/landing/blog?type=blog#3' },
  { title: n_landing.gnb_menu_4.list_2, link: '/student/landing/blog?type=blog#4' },
  { title: n_landing.gnb_menu_4.list_3, link: '/student/landing/blog?type=blog#0' },
] as const

interface GuideLavLinksProps {
  onNavBarClose?: () => void
}

const GuideLavLinks = ({ onNavBarClose }: GuideLavLinksProps) => {
  const router = useAppRouter()
  const { t } = useTranslation()

  const handleLinkClick = (link: string, onClose) => {
    router.push(link)
    onClose()
    onNavBarClose?.()
  }

  return (
    <MainNavDropdown navTitle={t(n_landing.gnb_menu_4.list)} path="landing/blog">
      {(onClose) => (
        <ul className="sm:p-8 pt-12 flex flex-col gap-y-4">
          {guides.map((guide, index) => (
            <li key={index} className="w-full hover:bg-purple-50 active:opacity-50 rounded group">
              <button className="p-10 w-full flex" onClick={() => handleLinkClick(guide.link, onClose)}>
                <span className="Body2-14Md sm:Caption-12Md text-gray-600 sm:text-black group-hover:text-purple-600 text-left">
                  {t(guide.title)}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </MainNavDropdown>
  )
}

export default GuideLavLinks
